import React from 'react'
import { getDemoServiceItems } from '../data/demoData';

export default function Service() {
  const items = getDemoServiceItems();
  return (
    <div style={{ padding: '20px' }}>
      <h2>Servis (Demo)</h2>
      {items.map((item) => (
        <div
          key={item.id}
          style={{
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '10px',
            background: '#fff'
          }}
        >
          <strong>{item.naziv}</strong> | {item.kategorija} | {item.status}
        </div>
      ))}
    </div>
  )
}
